import styled from 'styled-components';

import {
  Popup as SemanticPopup,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayout, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

const ContainerTrigger = styled.div`
  display: flex;
  min-width: 180px;
  justify-content: space-between;
  cursor: pointer;
`;

const Icon = styled(SemanticIcon)``;

const Loader = styled(LoaderLayoutComponent)``;

const Text = styled(TextLayout)`
  ${({ rightMargin }) => rightMargin && 'margin-right: 5px'};
  ${({ bold }) => bold && 'font-weight: 500;'};
`;

const Popup = styled(SemanticPopup)`
  &&&.ui.popup {
    padding: 12px 0;
  }
`;

export {
  ContainerTrigger,
  Icon,
  Loader,
  Text,
  Popup,
};
